import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import React from 'react';
import Content from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningModelAssignmentTemplate/EsgConfirmation/Content';

const Layout = () => (
  <WizardModalWrapperLayout
    primaryActionLabel={'I have read this to the client'}
  >
    <Content />
  </WizardModalWrapperLayout>
);

export default Layout;
